import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';

class StaffAttestationsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: this.props.staff_id,
      date: '',
      expiration: '',
      staff_attestations: [],
    };

    //bind específico
    this.add = this.add.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.refreshDataActive = this.refreshDataActive.bind(this);
    this.ativar = this.ativar.bind(this);
    this.desativar = this.desativar.bind(this);
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.staff_attestations)) {
      this.setState({
        staff_attestations: newProps.staff_attestations,
        loaded: 1
      });
    }
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.state.staff_id,
      date: this.state.date,
      expiration: this.state.expiration,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + '/colaborador/aso', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({ staff_attestations: responseJson.data });
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  // Fetch ativando um item
  ativar(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de ativar esse aso?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
        only_active: this.state.only_active,
        staff_id: this.state.staff_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api_sigmec') + '/colaborador/aso/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_attestations: responseJson.data });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  // Fetch deletando um item
  desativar(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de arquivar esse aso?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
        only_active: this.state.only_active,
        staff_id: this.state.staff_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api_sigmec') + '/colaborador/aso/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_attestations: responseJson.data });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  refreshData (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + '/colaborador/aso/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_attestations: responseJson.data, only_active: 0});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshDataActive (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigmec') + '/colaborador/aso/ativas/' + self.state.staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_attestations: responseJson.data, only_active: 1});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        }else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => { 
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">ASO</h3>
  <hr/>
  {(this.state.staff_attestations === null || typeof this.state.staff_attestations === 'undefined') ?  <div><small><em>Nenhuma aso cadastrado.</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">Data do exame</th>
          <th className="text-center">Vencimento</th>
          <th className="text-center">Status</th>
          <th className="col-md-1 text-center">Ações</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_attestations).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_attestations[k].date_str}</td>
              <td className="text-center">{self.state.staff_attestations[k].expiration_str}</td>
              <td className="text-center">{(self.state.staff_attestations[k].active === 1) ?  <span className="label label-success">ativo</span> : <span className="label label-danger">arquivado</span>}</td>
              <td className="text-center">
                {(self.state.staff_attestations[k].active === 1) ?  
                  <button className="btn btn-sm btn-danger" value={self.state.staff_attestations[k].id} onClick={self.desativar}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_attestations[k].id} onClick={self.ativar}><i className="fa fa-fw fa-power-off"></i></button>
                }
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  <h3 className="page-title">Adicionar aso</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Data do exame:</label>
        <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="" />
      </div>
      <div className="col-md-6 form-group">
        <label>Vencimento:</label>
        <InputMask value={this.state.expiration}  maskChar={null} name="expiration" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expiration')} placeholder="" />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar aso</button>
  </form>
</div>
    );
  }
}

export default StaffAttestationsTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffAttestationsTab.js